import { LocalJSONStorage } from '~/utils/js';
import type { WidgetMode } from './pdp/location-widget/types';

/**
 * The last location the user picked anywhere in the flow (PDP transport-calc
 * widget, teambuilding filter). Persisted so the checkout / wishlist location
 * fields can seed themselves without the user re-typing.
 */
export const LAST_LOCATION_STORAGE = new LocalJSONStorage<{
    query: string;
    lat: number;
    lng: number;
    radius: number | null;
} | null>('funkey:last-location', null, 'localStorage');

/**
 * The last delivery mode the user selected in the teambuilding filter
 * ("Ik ga naar de aanbieder" = fixed / "Aanbieder komt naar mij" = custom), so
 * the PDP widget opens in the same mode on a direct visit (no URL preset).
 */
export const LAST_LOCATION_MODE = new LocalJSONStorage<WidgetMode | null>(
    'funkey:last-location-mode',
    null,
    'localStorage',
);
